import {
    CLEAR_ALL_CUSTOMERS,
    STORE_ALL_CUSTOMERS, STORE_ALL_HISTORICAL_CUSTOMERS,
    STORE_ALL_RAFFLE_CUSTOMERS, STORE_ALL_RAFFLES, STORE_CUSTOMER_POINT_HISTORY,
    STORE_CUSTOMER_TICKET,
    STORE_CUSTOMERS_PENDING,
    STORE_CUSTOMERS_POINTS,
    STORE_UPDATED_CUSTOMER,
    STORE_UPDATED_CUSTOMER_IMAGE_WITH_PREVIEW,
    STORE_UPDATED_CUSTOMER_WITH_PREVIEW, STORE_UPDATED_POINT_WATCHING_IMAGE_WITH_PREVIEW, STORE_UPDATED_RAFFLE
} from "../../constants/customer";
import {STORE_POINT_WATCHING} from "../../constants/settings";
const initialState = {
    customers: [],
    raffleCustomers: [],
    customerPoints: [],
    customerPending: [],
    raffles: [],
    image: null,
    pointsWatching: [],
    previewPointImage: null,
    previewPhotoId: null,
    customerPointHistory: null,
    historicalCustomers: []
};

const addPreviewToCustomer = (updatedCustomerItem, oldCustomers) => {
    let filePreviewInfo = updatedCustomerItem.files.pop()
    let previewedFileIndex = filePreviewInfo.indexOfPreviewedFile
    let previewData = new Uint8Array(filePreviewInfo.previewedFile)
    let blobData = new Blob([previewData])
    updatedCustomerItem.files[previewedFileIndex]["localURL"] = URL.createObjectURL(blobData)
    updatedCustomerItem.files[previewedFileIndex]['byteArray'] = previewData

    let returnToUpdate = oldCustomers.find((customerItem) => { return customerItem.customerId === updatedCustomerItem.customerId })
    returnToUpdate.files[previewedFileIndex] = updatedCustomerItem.files[previewedFileIndex]

    return updateList(returnToUpdate, oldCustomers, "customerId")
}

export const updateList = (newItem, oldList, key) => {
    let newList = [...oldList]; // Create a copy of the old list

    // Check if the newItem already exists in the oldList
    let exists = oldList.findIndex(item => item[key] === newItem[key]);

    if (exists === -1) {
        // If not found, add the newItem to the end of the list
        newList.push(newItem);
    } else {
        // If found, replace the existing item with newItem
        newList[exists] = newItem;
    }

    return newList;
}

export const updateCustomerList = (newItem, oldList, key) => {
    const index = oldList.findIndex(item => item[key] === newItem[key]);

    if (index === -1) {
        return [...oldList, newItem];
    } else {
        const newList = [...oldList];

        // preserve capturedImageURL if the new item doesn't have one
        const oldItem = newList[index];

        newList[index] = {
            ...oldItem,
            ...newItem,
            capturedImageURL: newItem.capturedImageURL ?? oldItem.capturedImageURL
        };

        return newList;
    }
};


const convertB64ToFileFormat = (image) => {
    if (image.length === 0)
        return null
    let previewData = new Uint8Array(image)
    let blobData = new Blob([previewData])
    let localStorageUrl = URL.createObjectURL(blobData)
    return { localURL: localStorageUrl, displayName: "Image", byteArray: image, type: "" }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_UPDATED_CUSTOMER:
            return {
                ...state,
                customers: updateCustomerList(action.customer, state.customers, 'customerId')
            }
        case STORE_UPDATED_CUSTOMER_IMAGE_WITH_PREVIEW:
            return {
                ...state,
                image: convertB64ToFileFormat(action.previewedFile)
            }
        case STORE_UPDATED_POINT_WATCHING_IMAGE_WITH_PREVIEW:
            const pictureId =  convertB64ToFileFormat(action.data.previewPhotoId.previewPhotoId)
            return {
                ...state,
                previewPointImage: convertB64ToFileFormat(action.data.previewPointPicture.previewPointPicture),
                previewPhotoId: pictureId,
            }
        case STORE_UPDATED_CUSTOMER_WITH_PREVIEW:
            return {
                ...state,
                customers: addPreviewToCustomer(action.updatedCustomerItem, state.customers)
            }
        case STORE_ALL_CUSTOMERS:
            return {
                ...state,
                customers: action.data.customers
            }
        case STORE_ALL_HISTORICAL_CUSTOMERS:
            return {
                ...state,
                historicalCustomers: action.data.historicalCustomers
            }
        case STORE_CUSTOMER_POINT_HISTORY:
            return {
                ...state,
                customerPointHistory: action.pointHistory
            }
        case STORE_ALL_RAFFLE_CUSTOMERS:
            return {
                ...state,
                raffleCustomers: action.data
            }
        case CLEAR_ALL_CUSTOMERS:
            return {
                ...state,
                raffleCustomers: []
            }
        case STORE_CUSTOMERS_POINTS:
            return {
                ...state,
                customerPoints: action.data.customerPoints
            }
        case STORE_CUSTOMERS_PENDING:
            return {
                ...state,
                customerPending: action.data.customerPending
            }
        case STORE_CUSTOMER_TICKET:
            return {
                ...state,
                customerPending: updateList(action.customerPendingItem,state.customerPending, 'pendingId')
            }
        case STORE_ALL_RAFFLES:
            return {
                ...state,
                raffles: action.data.raffles
            }
        case STORE_UPDATED_RAFFLE:
            return {
                ...state,
                raffles: updateList(action.updatedRaffleItem, state.raffles, 'raffleId')
            }
        case STORE_POINT_WATCHING:
            return {
                ...state,
                pointsWatching: action.pointsWatching
            }
        default:
            return state
    }
}